import useIsInInspectionExperiment from '~/hooks/vdp/useIsInInspectionExperiment';
import ControlLowerSections, { OwnProps } from './ControlLowerSections';
import ExperimentLowerSections from './ExperimentLowerSections';

export default function LowerSections(props: OwnProps) {
  const isInInspectionExperiment = useIsInInspectionExperiment();

  return isInInspectionExperiment ? (
    <ExperimentLowerSections {...props} />
  ) : (
    <ControlLowerSections {...props} />
  );
}
